// extracted by mini-css-extract-plugin
export default {"drawerNavItemsContainer":"DrawerNavItems_drawerNavItemsContainer__WxZCi"};